<template>
  <div class="page-content" style="padding-top: 4rem">
    <div class="container-fluid">
      <div class="card" id="orderList">
        <div class="card-header border-0">
          <div class="d-flex align-items-center" style="text-align: left">
            <h5 class="card-title mb-0 flex-grow-1 fw-bold text-center">
              <span class="text-warning fs-5"> User Details </span> -
              {{ this.mobile }}
            </h5>
          </div>
        </div>

        <div class="card-body" style="text-align: left">
          <div class="row g-3">
            <div class="col-lg-4">
              <div>
                <label for="name" class="form-label"
                  >Full Name<span style="color: red">*</span></label
                >
                <input
                  type="text"
                  id="name"
                  v-model="name"
                  class="form-control"
                  placeholder="Enter Full Name"
                  required
                  disabled
                />
              </div>
            </div>
            <div class="col-lg-4">
              <div>
                <label for="email" class="form-label"
                  >Email<span style="color: red">*</span></label
                >
                <input
                  type="email"
                  id="email"
                  v-model="email"
                  class="form-control"
                  placeholder="Enter Email"
                  required
                  disabled
                />
              </div>
            </div>
            <div class="col-lg-4">
              <div>
                <label for="createdAt" class="form-label"
                  >Created At<span style="color: red">*</span></label
                >
                <input
                  id="createdAt"
                  v-model="createdAt"
                  class="form-control"
                  placeholder="Enter Email"
                  required
                  disabled
                />
              </div>
            </div>
            <div class="col-lg-4">
              <div>
                <label for="mobile" class="form-label"
                  >Contact Number<span style="color: red">*</span></label
                >
                <input
                  type="text"
                  id="mobile"
                  v-model="mobile"
                  class="form-control"
                  placeholder="Enter Mobile"
                  required
                  disabled
                />
              </div>
            </div>
            <div class="col-lg-4">
              <div>
                <label for="ref_by" class="form-label"
                  >Referral Code<span style="color: red">*</span></label
                >
                <input
                  type="text"
                  id="ref_by"
                  v-model="ref_by"
                  class="form-control"
                  placeholder="Enter Refered By"
                  required
                  disabled
                />
              </div>
            </div>
            <div class="col-lg-4">
              <div>
                <label for="age" class="form-label">Age</label>
                <input
                  type="number"
                  id="age"
                  v-model="age"
                  class="form-control"
                  placeholder="Enter Age"
                  required
                  disabled
                />
              </div>
            </div>

            <div class="col-lg-4">
              <div>
                <label for="age" class="form-label">Gender</label>
                <input
                  type="text"
                  id="gender"
                  v-model="gender"
                  class="form-control"
                  required
                  disabled
                />
              </div>
            </div>
            <div class="col-lg-4">
              <div>
                <label for="age" class="form-label">Total Referrals</label>
                <input
                  type="text"
                  id="gender"
                  v-model="refferalCount"
                  class="form-control"
                  required
                  disabled
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="container-fluid my-4">
        <div class="card shadow-sm p-4">
          <h5 class="fw-bold text-warning text-center">User Metrics</h5>
          <p class="text-muted mb-4 text-center">Summary</p>
          <div class="row g-3 text-start">
            <div
              class="col-md-3"
              v-for="(metric, index) in customerInfoDetails"
              :key="index"
            >
              <div
                class="p-3 rounded"
                :style="{ backgroundColor: metric.bgColor }"
              >
                <div class="mb-2">
                  <i
                    :class="metric.icon + ' fs-1 me-2'"
                    :style="{ color: metric.iconColor }"
                  ></i>
                  <br />
                </div>
                <h4
                  class="mb-0 fw-bold fs-3"
                  :style="{ color: metric.textColor || '#000' }"
                >
                  {{ metric.value }}
                </h4>
                <small
                  class="fs-6"
                  :style="{ color: metric.textColor || '#000' }"
                  >{{ metric.label }}</small
                >
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="container-fluid my-4" v-if="wallet.id">
        <div class="card shadow-sm p-4">
          <div class="d-flex justify-content-between">
            <div>
              <h5 class="fw-bold text-warning text-start">User Wallet</h5>
              <p class="text-muted mb-4 text-start">Summary</p>
            </div>
            <div class="bg-success bg-opacity-25 p-3 rounded">
              <h5 class="fw-bold fs-5 mb-2">
                <i class="ri-wallet-3-line fs-5 text-success me-2"></i>

                Wallet Balance
              </h5>

              <h6 class="fs-5 fw-bold text-center">{{ walletBalance }}</h6>
            </div>

            <div>
              <button
                class="btn btn-warning d-flex align-items-center"
                @click="showWaletDialog = true"
              >
                <i class="ri-add-line fs-4 me-2"></i>
                Add Walet Points
              </button>
            </div>
          </div>

          <div class="container-fluid mt-5 table-responsive table-card">
            <rb-data-table
              :headers="headers"
              :tableData="formattedTransactions"
              :ldata="ldata"
              :editBtn="false"
              :deleteBtn="false"
            />
          </div>
        </div>
      </div>

      <div
        class="modal fade show d-block"
        tabindex="-1"
        v-if="showWaletDialog"
        style="background-color: rgba(0, 0, 0, 0.5)"
      >
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content" style="min-width: 700px">
            <div class="modal-header bg-warning py-4">
              <h5 class="modal-title text-white fw-bold">Add Wallet Points</h5>
              <button
                type="button"
                class="btn-close text-white"
                @click="showWaletDialog = false"
              ></button>
            </div>
            <div class="modal-body text-start">
              <label>Enter wallet Points:</label>
              <input
                type="number"
                v-model="wallet.points"
                class="form-control"
              />

              <label class="mt-2">Type :</label>
              <select v-model="wallet.depositType" class="form-control">
                <option value="">Select Type</option>
                <option value="credit">Credit</option>
                <option value="debit">Debit</option>
              </select>
              <br />

              <label>Reference Id:</label>
              <input v-model="wallet.referenceId" class="form-control" />
              <label class="mt-2">Reference Type</label>
              <select v-model="wallet.referenceType" class="form-control">
                <option value="">Select Type</option>
                <option value="promo">Promo</option>
                <option value="refund">refund</option>
                <option value="wallet_topup">Wallet Topup</option>
                <option value="welcome_bonus">Welcome Bonus</option>
              </select>
              <br />

              <textarea
                v-model="wallet.comment"
                id="commentInput"
                rows="5"
                class="form-control"
                placeholder="Write your comment here..."
              ></textarea>
            </div>
            <div class="modal-footer">
              <button
                class="btn border border-warning text-warning w-25"
                @click="showWaletDialog = false"
              >
                Cancel
              </button>
              <button
                type="button"
                class="btn w-25 bg-warning"
                @click="addWalletPoints"
              >
                <div
                  v-if="loading"
                  class="spinner-border spinner-border-sm text-white"
                  role="status"
                ></div>
                <div v-else class="text-white">Add Points</div>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ToastNotification ref="toast" />
    <LoaderLoading v-if="loaderLoading" />
  </div>
</template>

<script>
import { getWalletById, createWallet } from "@/apis/wallet";
import { walletHeaders } from "@/constants/headers";
import entityFormMixin from "@/mixins/entityFormMixin";
import { customerInfoDetails } from "@/constants/infodetails";

export default {
  name: "viewCustomer",

  mixins: [entityFormMixin],

  data() {
    return {
      transactions: [],

      wallet: {
        id: null,
        points: null,
        referenceId: null,
        referenceType: null,
        comment: null,
        depositType: null,
      },

      headers: walletHeaders,
      customerInfoDetails: customerInfoDetails,

      showWaletDialog: false,
      loaderLoading: false,
    };
  },

  methods: {
    async getWalletDetails(id) {
      const response = await getWalletById(id);

      if (response.success) {
        this.walletBalance = response.data.wallet_balance;
        this.transactions = response.data.wallet_transactions;
      }
    },

    async addWalletPoints() {
      const response = await this.save(
        this.wallet.id,
        {
          initiatorEmail: this.ldata.email,
          ...this.wallet,
        },
        createWallet,
        null
      );

      if (response.success) {
        this.getWalletDetails(this.wallet.id);
        this.showWaletDialog = false;
        this.clearWalletData();
      }
    },

    clearWalletData() {
      const { id } = this.wallet;
      this.wallet = {
        id,
        points: null,
        referenceId: null,
        referenceType: null,
        comment: null,
        depositType: null,
      };
    },
  },

  async mounted() {
    this.loaderLoading = true;

    if (this.userEditData) {
      const {
        name,
        email,
        created_at,
        referral_count,
        phone_number,
        gender,
        age,
        referral_code,
        total_revenue,
        totalBookings,
        search_count,
        cancelledBooking,
        wallet_details,
      } = this.userEditData;

      this.name = name || "N/A";
      this.age = age || "N/A";
      this.gender = gender || "N/A";
      this.email = email || "N/A";
      this.mobile = phone_number;
      this.ref_by = referral_code || "N/A";
      this.createdAt = created_at || "N/A";
      this.refferalCount = referral_count;

      this.wallet.id = wallet_details.wallet_id;
      
      if (this.wallet.id) await this.getWalletDetails(this.wallet.id);

      this.customerInfoDetails[0].value = total_revenue || 0;
      this.customerInfoDetails[1].value = totalBookings;
      this.customerInfoDetails[2].value = cancelledBooking;
      this.customerInfoDetails[3].value = search_count;
    }

    this.loaderLoading = false;
  },

  computed: {
    formattedTransactions() {
      return this.transactions.map((transaction, index) => ({
        sno: index + 1,
        CreatedAt: transaction.created_at
          ? new Date(transaction.created_at).toLocaleString()
          : "N/A",
        amount: transaction.amount || "N/A",
        balanceAfterTransactions:
          transaction.balance_after_transaction || "N/A",
        type: transaction.type || "N/A",
        referenceType: transaction.reference_type,
        referenceID: transaction.reference_id || "N/A",
        descriptions: transaction.description || "N/A",
        initiatorID: transaction.initiator_id,
      }));
    },
  },
};
</script>
